import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';

import * as _ from 'lodash';
import * as moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { ReportsService } from 'src/app/modules/retailer/services/reports.service';

interface IRange {
  value: Date[];
  label: string;
}
@Component({
  selector: 'app-coupon-detailed-report',
  templateUrl: './coupon-detailed-report.component.html',
  styleUrls: ['./coupon-detailed-report.component.scss']
})
export class CouponDetailedReportComponent implements OnInit {

  public loginData: any;
  public selectedCouponDetails: any;

  public selectedCouponProducts: any = [];
  public productSelectionSettings: IDropdownSettings;
  public selectedProducts: any = [];

  public reportateRange: any = [];
  public reportDays: any;
  public compareDateRange: any = [];
  public compareDays: any;
  public calendarModalRef?: BsModalRef;
  public calendarRanges: IRange[] = [];
  public calendarConfig;
  public calendarMinDate: Date;
  public calendarMaxDate: Date;

  public couponRedemptionData: any = { datasets: [] };;
  public couponRedemptionReportLoading: boolean = false;
  public couponData: any;
  public couponDetailedReportLoading: boolean = false;

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _reportsService: ReportsService,
    private _modalService: BsModalService
  ) {
    this.selectedCouponDetails = this._router.getCurrentNavigation().extras.state;
  }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    // Back to coupons report page if selected coupons details is missing
    if (!this.selectedCouponDetails) {
      this._router.navigate(['/retailer/reports']);
    } else {
      // Product selection settings
      this.productSelectionSettings = {
        singleSelection: false,
        idField: 'upc',
        textField: 'item_name',
        selectAllText: 'Select All Products',
        unSelectAllText: 'UnSelect All Products',
        //itemsShowLimit: 3,
        allowSearchFilter: false,
        enableCheckAll: false,
      };

      // Set coupon products
      this.selectedCouponProducts = this.selectedCouponDetails.coupon.products;

      // Select all products by default
      this.selectedProducts = this.selectedCouponProducts

      // Set report date range
      this.reportateRange = [new Date(moment(this.selectedCouponDetails.coupon.start_date).utc().format('YYYY-MM-DD')), new Date(moment(this.selectedCouponDetails.coupon.coupon_expiration.date).utc().format('YYYY-MM-DD'))];
      if(moment(this.reportateRange[1]).diff(moment(), 'days') > 0) { // Report end date greater than today
        this.reportateRange[1] = moment().utc().format('YYYY-MM-DD'); // Set today as end date
      }
      this.reportDays = moment(this.reportateRange[1]).diff(this.reportateRange[0], 'days') + 1; // No of days between report start and end dates

      // Set compare date range - Previous X days
      this.compareDateRange = [new Date(moment(this.reportateRange[0]).subtract(this.reportDays, "days").format('YYYY-MM-DD')), new Date(moment(this.reportateRange[0]).subtract(1, "days").format('YYYY-MM-DD'))];
      this.compareDays = moment(this.compareDateRange[1]).diff(this.compareDateRange[0], 'days') + 1; // No of days between compare start and end dates

      // Set compare date range calendar min & max dates
      this.calendarMinDate = new Date(moment(this.reportateRange[0]).subtract(3, 'years').format('YYYY-MM-DD')); // Report start date - 3 years
      this.calendarMaxDate = new Date(moment(this.reportateRange[0]).subtract(1, 'days').format('YYYY-MM-DD')); // Report start date - 1 day

      // Set compare date calendar range
      let sevenDaysBefore = moment(this.reportateRange[0]).subtract(1, 'days');
      this.calendarRanges = [
        { value: [new Date(moment(this.reportateRange[0]).subtract(7, 'days').format('YYYY-MM-DD')), new Date(moment(this.reportateRange[0]).subtract(1, 'days').format('YYYY-MM-DD'))],  label: 'Last 7 Days'}, // Last 7 days from start date
        { value: [new Date(moment(this.reportateRange[0]).subtract(30, 'days').format('YYYY-MM-DD')), new Date(moment(this.reportateRange[0]).subtract(1, 'days').format('YYYY-MM-DD'))],  label: 'Last 30 Days'}, // Last 30 days from start date
        { value: [new Date(moment(this.reportateRange[0]).subtract(365, 'days').format('YYYY-MM-DD')), new Date(moment(this.reportateRange[0]).subtract(1, 'days').format('YYYY-MM-DD'))],  label: 'Last 365 Days'}, // Last 365 days from start date
        { value: [new Date(moment(this.reportateRange[0]).subtract(this.reportDays, 'days').format('YYYY-MM-DD')), new Date(moment(this.reportateRange[0]).subtract(1, 'days').format('YYYY-MM-DD'))],  label: 'Last ' + this.reportDays + ' Days'}, // Last X days from start date
      ];

      // Set compare date calendar configurations
      this.calendarConfig = { adaptivePosition: true, dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-blue', showWeekNumbers: false, ranges: this.calendarRanges };

      this.getCouponRedemptionReport();
      this.getCouponsDetailedReport();
    }
  }

  // Back to coupons report
  onBackClick(){
    this._router.navigate(['/retailer/reports'], {
      state: {
        filter: this.selectedCouponDetails.filter,
        page: this.selectedCouponDetails.page,
        coupon: this.selectedCouponDetails.coupon
      }
    });
  }

  // On Product select
  onProductSelect(store: any) {
    this.selectedProducts.push(store);

    this.getCouponRedemptionReport();
    this.getCouponsDetailedReport();
  }

  // On Product deselect
  onProductDeSelect(store: any) {
    if (this.selectedProducts.length >= 1)  {
      this.selectedProducts = _.filter(this.selectedCouponProducts, obj => obj.upc != store.upc);

      this.getCouponRedemptionReport();
      this.getCouponsDetailedReport();
    } else {
      this._utilService.showToast('At least one produt should be selected.', '', 'warning', {});

      // Select all products by default
      setTimeout(() => {
        this.selectedProducts = this.selectedCouponProducts;

        this.getCouponRedemptionReport();
        this.getCouponsDetailedReport();
      }, 100);
    }
  }

  // Open calendar modal
  openCalendarModal(template: TemplateRef<any>) {
    this.calendarModalRef = this._modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg' })
    );
  }

  // On compare calendar value change
  onCalendarValueChange(event: any) {
    if(this.compareDateRange[0] != event[0] && this.compareDateRange[1] != event[1]) { // Compare date changed
      this.compareDateRange = event;

      // Set no of days between compare start and end dates
      this.compareDays = moment(this.compareDateRange[1]).diff(this.compareDateRange[0], 'days') + 1; //

      this.getCouponRedemptionReport();
      this.getCouponsDetailedReport();

      this.calendarModalRef.hide();
    }
  }

  // Get coupon redemption report
  getCouponRedemptionReport () {
    this.couponRedemptionReportLoading = true;
    this.couponRedemptionData = { datasets: [] };

    // Get selected products upc's
    let selected_upc: any = _.map(this.selectedProducts, 'upc');

    let getCouponRedemptionReportBody = {
      provider_type: this.loginData.user_details.provider_type,
      provider_id: this.loginData.user_details.provider_id,
      retailer_id: this.loginData.user_details.provider_id,
      store_id: this.selectedCouponDetails.coupon.store_id,
      coupon_id: this.selectedCouponDetails.coupon.coupon_id,
      start_date: moment(this.selectedCouponDetails.coupon.start_date).utc().format('YYYY-MM-DD'),
      end_date: moment(this.selectedCouponDetails.coupon.coupon_expiration.date).utc().format('YYYY-MM-DD'),
      upc: selected_upc
    };

    this._reportsService.getCouponRedemptionReport(this.loginData.token, getCouponRedemptionReportBody).subscribe(async getCouponRedemptionReportResponse => {
      this.couponRedemptionReportLoading = false;

      if (getCouponRedemptionReportResponse.status === true) { // Success
        // Prepare line chart data
        let tempLineChartData: any = {
          datasets: []
        };

        for (let i=0; i<=getCouponRedemptionReportResponse.data.length - 1; i++) {
          tempLineChartData.datasets.push({
            label: getCouponRedemptionReportResponse.data[i].store_name,
            lineTension: 0.5,
            radius: 4,
            borderWidth: 2,
            fill: false,
            data: []
          });

          for (let j=0; j<=getCouponRedemptionReportResponse.data[i].store_data.length - 1; j++) {
            tempLineChartData.datasets[i].data.push({
              x: moment(getCouponRedemptionReportResponse.data[i].store_data[j].date).utc().format('MMM D YYYY'),
              y: getCouponRedemptionReportResponse.data[i].store_data[j].item_amount
            });
          }
        }

        this.couponRedemptionData = tempLineChartData;
      } else {
        this._utilService.showToast(getCouponRedemptionReportResponse.message, '', 'error', {});
      }
    }, error => { // Error from getCouponRedemptionReport
      this.couponRedemptionReportLoading = false;
    });
  }

  // Get coupon detailed report
  getCouponsDetailedReport() {
    this.couponDetailedReportLoading = true;
    this.couponData = {
      reportDataAll: [],
      reportDataSelectedStore: [],
      compareDataAll: [],
      compareDataSelectedStore: [],
      salesAmountPercentageChange: null,
      basketCountPercentageChange: null,
      avgBasketSizePercentageChange: null,
      storeData: []
    };

    // Get selected products upc's
    let selected_upc: any = _.map(this.selectedProducts, 'upc');

    let getCouponDetailedReportBody = {
      provider_type: this.loginData.user_details.provider_type,
      provider_id: this.loginData.user_details.provider_id,
      retailer_id: this.loginData.user_details.provider_id,
      store_id: this.selectedCouponDetails.coupon.store_id,
      mode: 'coupon',
      coupon_id: this.selectedCouponDetails.coupon.coupon_id,
      start_date: moment(this.reportateRange[0]).format('YYYY-MM-DD'), // this.reportStartDate,
      end_date: moment(this.reportateRange[1]).format('YYYY-MM-DD'), // this.reportEndDate,
      upc: selected_upc
    };

    let getCouponDetailedCompareBody = {
      provider_type: this.loginData.user_details.provider_type,
      provider_id: this.loginData.user_details.provider_id,
      retailer_id: this.loginData.user_details.provider_id,
      store_id: this.selectedCouponDetails.coupon.store_id,
      mode: 'date',
      coupon_id: this.selectedCouponDetails.coupon.coupon_id,
      start_date: moment(this.compareDateRange[0]).format('YYYY-MM-DD'), //this.compareStartDate,
      end_date: moment(this.compareDateRange[1]).format('YYYY-MM-DD'), //this.compareEndDate,
      upc: selected_upc
    };

    forkJoin([
      this._reportsService.getCouponDetailedReport(this.loginData.token, getCouponDetailedReportBody),
      this._reportsService.getCouponDetailedReport(this.loginData.token, getCouponDetailedCompareBody)
    ]).subscribe(results => {
      this.couponDetailedReportLoading = false;

      if (results[0].status === true && results[1].status === true) { // Success
        this.couponData.reportDataAll = results[0].data;
        this.couponData.compareDataAll = results[1].data;

        // Report data for selected store
        this.couponData.reportDataSelectedStore = _.filter(this.couponData.reportDataAll, obj => obj.store_id == this.selectedCouponDetails.coupon.store_id);

        // Compare data for selected store
        this.couponData.compareDataSelectedStore = _.filter(this.couponData.compareDataAll, obj => obj.store_id == this.selectedCouponDetails.coupon.store_id);

        // Sales amount percentage change
        this.couponData.salesAmountPercentageChange = this._utilService.getPercentageChange(this.couponData.compareDataSelectedStore[0].item_amount, this.couponData.reportDataSelectedStore[0].item_amount, false);

        // Basket count percentage change
        this.couponData.basketCountPercentageChange = this._utilService.getPercentageChange(this.couponData.compareDataSelectedStore[0].basket_count, this.couponData.reportDataSelectedStore[0].basket_count, false);

        // Avg basket size percentage change
        this.couponData.avgBasketSizePercentageChange = this._utilService.getPercentageChange(this.couponData.compareDataSelectedStore[0].avg_basket_size, this.couponData.reportDataSelectedStore[0].avg_basket_size, false);

        // Store level data
        for (let i=0; i<=this.couponData.reportDataAll.length - 1; i++) {
          // Get compare data
          let tempCompareSalesAmount: any = 0;
          let tempCompareUnitsSold: any = 0;
          let tempSalesDiff: any = 0;

          let tempCompareStoreData = _.filter(this.couponData.compareDataAll, obj => obj.store_id == this.couponData.reportDataAll[i].store_id);
          if (tempCompareStoreData.length > 0) { // Compare store data exists
            tempCompareSalesAmount = tempCompareStoreData[0].item_amount;
            tempCompareUnitsSold = tempCompareStoreData[0].units_sold;
            tempSalesDiff = this._utilService.getPercentageChange(tempCompareSalesAmount, this.couponData.reportDataAll[i].item_amount, false);
          }

          this.couponData.storeData.push({
            store_id: this.couponData.reportDataAll[i].store_id,
            store_name: this.couponData.reportDataAll[i].store_name,
            report_sales_amount: this.couponData.reportDataAll[i].item_amount,
            report_units_sold: this.couponData.reportDataAll[i].units_sold,
            compare_sales_amount: tempCompareSalesAmount,
            compare_units_sold: tempCompareUnitsSold,

            sales_diff: tempSalesDiff,
            chartHeight: 50,
            chartData: {
              labels: [this.couponData.reportDataAll[i].store_name],
              datasets: [
                {  maxBarThickness: 15, barThickness: 'flex', backgroundColor: environment.report_data_color, data: [this.couponData.reportDataAll[i].item_amount], label: 'Report sales amount' },
                {  maxBarThickness: 15, barThickness: 'flex', backgroundColor: environment.compare_data_color, data: [ tempCompareSalesAmount ], label: 'Compare sales amount' }
              ]
            }
          });
        }
      } else {
        if (results[0].status === true) { // Error from report data call
          this._utilService.showToast(results[0].message, '', 'error', {});
        } else { // Error from compare data call
          this._utilService.showToast(results[1].message, '', 'error', {});
        }
      }
    }, error => { // Error from getCouponDetailedReport
      this.couponDetailedReportLoading = false;
    });
  }


}
